import React, { useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

// API base path from environment variable, defaults to empty string for relative paths
const API_BASE_PATH = process.env.REACT_APP_RESOAPI_BASE_URL || "";
const WEBAPI_BASE_PATH = process.env.REACT_APP_WEBAPI_BASE_URL || "";
const Login = ({ show, onClose, onSwitchToSignup }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const modalRef = useRef();
  const modalInstanceRef = useRef(null);
React.useEffect(() => {
  function handleOpenLoginModal() {
    if (modalRef.current && window.bootstrap) {
      try {
        // Use getOrCreateInstance but ensure backdrop is enabled
        let instance = window.bootstrap.Modal.getInstance(modalRef.current);
        if (!instance) {
          // Create new instance with backdrop enabled
          instance = new window.bootstrap.Modal(modalRef.current, {
            backdrop: true,
            focus: true,
            keyboard: true,
          });
          modalInstanceRef.current = instance;
        } else {
          // If instance exists, ensure backdrop config is set
          if (instance._config) {
            instance._config.backdrop = true;
          }
          modalInstanceRef.current = instance;
        }
        if (!instance._isShown) {
          instance.show();
        }
      } catch (error) {
        console.error("Error opening login modal:", error);
      }
    }
  }
  window.addEventListener('openLoginModal', handleOpenLoginModal);
  return () => window.removeEventListener('openLoginModal', handleOpenLoginModal);
}, []);

  React.useEffect(() => {
    if (show && modalRef.current && window.bootstrap) {
      try {
        // Use getOrCreateInstance but ensure backdrop is enabled
        let instance = window.bootstrap.Modal.getInstance(modalRef.current);
        if (!instance) {
          // Create new instance with backdrop enabled
          instance = new window.bootstrap.Modal(modalRef.current, {
            backdrop: true,
            focus: true,
            keyboard: true,
          });
          modalInstanceRef.current = instance;
        } else {
          // If instance exists, ensure backdrop config is set
          if (instance._config) {
            instance._config.backdrop = true;
          }
          modalInstanceRef.current = instance;
        }
        if (!instance._isShown) {
          instance.show();
        }
      } catch (error) {
        console.error("Error opening login modal:", error);
      }
    } else if (!show && modalRef.current && window.bootstrap) {
      // Hide modal when show is false
      try {
        const modal = modalInstanceRef.current || window.bootstrap.Modal.getInstance(modalRef.current);
        if (modal && modal._isShown) {
          modal.hide();
        }
        modalInstanceRef.current = null;
      } catch (error) {
        console.error("Error closing login modal:", error);
      }
    }
    // Cleanup on unmount
    return () => {
      if (modalInstanceRef.current && modalInstanceRef.current._isShown) {
        try {
          modalInstanceRef.current.hide();
        } catch (error) {
          // Ignore errors during cleanup
        }
      }
      modalInstanceRef.current = null;
      // Remove any lingering .modal-backdrop
      const backdrops = document.querySelectorAll(".modal-backdrop");
      backdrops.forEach((el) => {
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });
    };
  }, [show]);

  const setUserCookieAndGlobal = (userObj) => {
    // Set cookie for 7 days
    document.cookie = `userInfo=${encodeURIComponent(JSON.stringify(userObj))}; path=/; max-age=${7 * 24 * 60 * 60}`;
    // Set global object
    window.isUserLoggedIn = true;
    window.userInfo = userObj;
    window.dispatchEvent(new Event('loginStatusChanged'));
  };
 // After successful signup, set user info in localStorage and window
  const handleSignupSuccess = (userInfo) => {
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    window.userInfo = userInfo;
    window.isUserLoggedIn = true;
    window.dispatchEvent(new Event("loginStatusChanged"));
  };

  // Function to remove all modal overlays and backdrops
  const removeAllModalOverlays = () => {
    // Remove all modal backdrops
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      } else {
        el.remove();
      }
    });

    // Remove modal-open class from body
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

    // Hide all open modals
    const allModals = document.querySelectorAll(".modal.show");
    allModals.forEach((modal) => {
      modal.classList.remove("show");
      modal.style.display = "none";
      modal.setAttribute("aria-hidden", "true");
      modal.removeAttribute("aria-modal");
    });

    // Dispose all Bootstrap modal instances
    if (window.bootstrap && window.bootstrap.Modal) {
      const modalElements = document.querySelectorAll(".modal");
      modalElements.forEach((modalEl) => {
        try {
          const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
          if (modalInstance) {
            modalInstance.hide();
            modalInstance.dispose && modalInstance.dispose();
          }
        } catch (error) {
          // Ignore errors
        }
      });
    }
  };

  // Enhanced close handler that removes all overlays
  const handleClose = () => {
    // Hide the login modal
    if (modalRef.current && window.bootstrap) {
      try {
        const modal = modalInstanceRef.current || window.bootstrap.Modal.getInstance(modalRef.current);
        if (modal) {
          modal.hide();
        }
      } catch (error) {
        // Ignore errors
      }
    }
    
    // Remove all modal overlays
    removeAllModalOverlays();
    
    // Call the original onClose callback
    if (onClose) onClose();
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      UserEmailId: email,
      Password: password,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${WEBAPI_BASE_PATH}/PlanetREAPI/api/Visitor/Login`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        setLoading(false);
        var jsonresult = JSON.parse(result);
        if (jsonresult.success === "true") {
          // Map the required fields
          const mapped = {
            FirstName: jsonresult.FirstName,
            MiddleName: jsonresult.MiddleName,
            LastName: jsonresult.LastName,
            EmailId: jsonresult.EmailId,
            PhoneNumber: jsonresult.PhoneNumber,
            VisitorId: jsonresult.VisitorId,
            Address: jsonresult.Address,
            City: jsonresult.City,
            State: jsonresult.State,
            Zip: jsonresult.Zip,
          };
          setUserCookieAndGlobal(mapped);
          handleSignupSuccess(mapped); // Call handleSignupSuccess(userInfo) after login is successful
          // Close modal using Bootstrap API
          if (modalRef.current && window.bootstrap) {
            const modalInstance = window.bootstrap.Modal.getOrCreateInstance(modalRef.current);
            modalInstance.hide();
          }
          if (onClose) onClose();
        } else {
          setError("Invalid username/password. Please try again!");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
        setError("Invalid username/password. Please try again!");
      });
  };

  return (
    <div
      className={`modal${show ? " show" : ""}`}
      id="logininfoModal"
      tabIndex="-1"
      aria-labelledby="logininfoModalLabel"
      aria-hidden={!show}
      ref={modalRef}
      style={{ display: show ? "block" : "none" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content rounded-4 overflow-hidden"
          style={{ backgroundColor: "rgba(86, 135, 143, 1)", color: "#fff" }}
        >
          <div
            className="modal-header border-4 justify-content-center position-relative"
            style={{ height: "110px" }}
          >
            <div className="position-absolute start-0 top-0 p-3">
              <img
                src={require("../assets/image/footer/Capture_cleanup.png")}
                width="100px"
                height="100px"
              />
            </div>

            <h3
              className="modal-title w-100 text-center fw-bold"
              id="logininfoModalLabel"
            >
              LOGIN
            </h3>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>

          <div className="modal-body px-4 mt-4">
            {error && <div className="alert alert-danger">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <input
                  type="email"
                  className="form-control"
                  id="UserEmailId"
                  name="UserEmailId"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email address"
                  required
                />
              </div>

              <div className="mb-3">
                <input
                  type="password"
                  className="form-control"
                  id="Password"
                  name="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  required
                />
              </div>
              <div className="d-grid">
                <button
                  type="submit"
                  className="btn btn-info rounded-pill text-white fw-semibold"
                  id="loginbtn"
                  disabled={loading}
                >
                  {loading ? 'Logging in...' : 'Login'}
                </button>
              </div>
            </form>

            <div className="mt-3 text-center">
              <span>Don't have an account? </span>
              <button className="btn btn-link p-0 AuthLinkCTA" onClick={onSwitchToSignup}>
                Sign Up
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    // <div
    //   className="modal fade"
    //   tabIndex="-1"
    //   style={{ display: show ? "block" : "none" }}
    //   ref={modalRef}
    //   aria-modal="true"
    //   role="dialog"
    // >
    //   <div className="modal-dialog modal-dialog-centered">
    //     <div className="modal-content p-4">
    //       <div className="modal-header border-0">
    //         <h2 className="mb-0 w-100 text-center">Login</h2>
    //         <button type="button" className="btn-close" onClick={onClose}></button>
    //       </div>
    //       <div className="modal-body">
    //         {error && <div className="alert alert-danger">{error}</div>}
    //         <form onSubmit={handleSubmit}>
    //           <div className="mb-3">
    //             <label htmlFor="email" className="form-label">Email address</label>

    //           </div>
    //           <div className="mb-3">
    //             <label htmlFor="password" className="form-label">Password</label>

    //           </div>
    //           <button type="submit" className="btn btn-primary w-100">Login</button>
    //         </form>

    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default Login;
